import React from 'react';
import { Box, Typography } from '@common-ui/ui';
import { flushPendo } from '../../utils/analytics/pendoAnalytics';
import { useHistory } from 'react-router-dom';
import routerPathEnum from '../../enums/routerPathEnum';

function LogoutScreen() {
  const history = useHistory();

  flushPendo();
  sessionStorage.clear();
  localStorage.clear();
  history.push({ pathname: routerPathEnum.LOGIN });

  return (
    <Box sx={container}>
      <Typography variant="h5">You have been logged out</Typography>
    </Box>
  );
}

export default LogoutScreen;

const container = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  color: 'grey.100',
  backgroundColor: 'background.paper',
};
